import { defineMessages } from 'react-intl';

const messages = defineMessages({
    pageTitle: {
        id:'pageTitlePrivacyPolicy',
        defaultMessage: 'LabXchange Online Privacy Policy',
        description: 'HTML title for the privacy policy page.',
    },
    pageSubTitle: {
        id:'pageSubTitlePrivacyPolicy',
        defaultMessage: 'Dated: September 23, 2019',
        description: 'Publish date for the privacy policy page.',
    },
});

export default messages;
